// eslint-disable-next-line no-restricted-imports
import {
  ContactDto,
  Query_ClientController_GetById_OrderSubmissionContacts_Items_Type,
} from 'api/generated/graphql';
import { OrderSubmissionContactType } from 'api/types/entity';
import { lodash } from 'helpers';

export const parseOrderSubmissionContactEntity = ({
  type,
  value,
}: {
  value: string;
  type: Query_ClientController_GetById_OrderSubmissionContacts_Items_Type;
}): {
  value: string;
  type: OrderSubmissionContactType;
} => ({
  value,
  type: OrderSubmissionContactType[type],
});

export const parseOrderSubmissionContactsEntity = (
  orderSubmissionContacts?: (ContactDto | null)[] | null
) =>
  orderSubmissionContacts
    ? lodash
        .compact(orderSubmissionContacts)
        .map(parseOrderSubmissionContactEntity)
    : undefined;
